import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_TASK } from "../task.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateTaskInput } from "../../../__generated__/globalTypes";
import {
  UpdateTaskMutation,
  UpdateTaskMutationVariables,
} from "../../../__generated__/UpdateTaskMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateTask = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateTaskInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateTaskMutation,
    UpdateTaskMutationVariables
  >(UPDATE_TASK, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateTask?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateTask?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
